import { call, put, takeEvery } from 'redux-saga/effects';
import { golfApi } from 'config/axios';
import { toQueryString } from 'utils/UrlUtil';

import {
    FETCH_GOLF_PROFILE,
    FETCH_GOLF_PROFILE_SUCCESS,
    FETCH_GOLF_PROFILE_FAIL
} from '../actions/golfProfileActions.js';

export function* fetchGolfProfileSaga(action) {
    try {
        const queryString = toQueryString({
            displayName: action.displayName
        });

        const url = `/gcs-golfcommunity/api/v2/player/profile${queryString}`;

        const response = yield call(golfApi.get, url);

        yield put({
            type: FETCH_GOLF_PROFILE_SUCCESS,
            golfProfile: response.data,
            displayName: action.displayName
        });
    } catch (e) {
        yield put({
            type: FETCH_GOLF_PROFILE_FAIL,
            golfProfile: {}
        });
    }
}

export const golfProfile = [takeEvery(FETCH_GOLF_PROFILE, fetchGolfProfileSaga)];
